<template>
  <b-container fluid
    ><b-row
      :style="{ background: course.color }"
      :class="{ 'bar_pointer-hover': isStaff }"
      @click="setNextSessionDate"
    >
      <b-col class="tsny_text tsny_text-mid text-white pt-1 pb-1 pl-4">
        <i class="fa fa-exclamation-circle" v-if="isStaff && reportDue" />
        <span class="mr-3">
          Next Session:
        </span>
        <span>
          {{ nextSessionDateFormatted }}
        </span>
        <span v-if="course.nextSessionDate">
          {{ nextSessionTimeFormatted }}
        </span>
      </b-col>
    </b-row>
    <set-next-session-date-modal :course="course" />
  </b-container>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import StoreConstants from "../../store/services/StoreConstants";
import SetNextSessionDateModal from "./SetNextSessionDateModal";

export default {
  name: "NextSessionBar",
  components: { SetNextSessionDateModal },
  props: {
    course: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isStaff: StoreConstants.GETTERS.IS_STAFF,
      reportDueGetter: StoreConstants.GETTERS.IS_SESSION_REPORT_DUE
    }),
    reportDue: function() {
      return this.reportDueGetter(this.course._id);
    },
    nextSessionDateFormatted: function() {
      return this.course.nextSessionDate
        ? moment(this.course.nextSessionDate).format("MMMM DD, YYYY")
        : "TBD";
    },
    nextSessionTimeFormatted: function() {
      return this.course.nextSessionStartTime && this.course.nextSessionEndTime
        ? `from ${moment(this.course.nextSessionStartTime, "h:mm a").format(
            "hA"
          )}-${moment(this.course.nextSessionEndTime, "h:mm a").format("hA")}`
        : "Time TBD";
    }
  },
  methods: {
    setNextSessionDate() {
      if (this.isStaff) {
        this.$bvModal.show("setNextSessionDateModal");
      }
    }
  }
};
</script>

<style scoped>
.bar_pointer-hover:hover {
  cursor: pointer;
}
</style>
